let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("fS2Ur")).then(() => parcelRequire('fStAt'));